import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderCarrierAccountStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderCarrierAccount?: TypographyProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderCarrierAccountStyles: OrderCarrierAccountStyles = {
    wrapper: {
        css: css`
            font-family: 'Lato',sans-serif;
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 0.75rem;
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            color: #002554;		
            font-size: 0.875rem;
            font-family: 'Roboto', sans-serif;
            font-weight: bold;
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    orderCarrierAccount: {
        css: css`
            color: #333F48;
            font-size: 0.875rem;
    `, 
    },
};

const styles = orderCarrierAccountStyles;
const OrderCarrierAccount: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);
    if ((!order || !order?.properties?.customerFreightBillingAcctNumber)&&(!orderData ||!orderData?.properties?.customerFreightBillingAcctNumber)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderCarrierAccount">
                {translate("Carrier Account #")}
            </Typography>
            <Typography {...styles.orderCarrierAccount} aria-labelledby="orderCarrierAccount" data-test-selector="orderCarrierAccount">
                {order?.properties?.customerFreightBillingAcctNumber||orderData?.properties?.customerFreightBillingAcctNumber}
            </Typography>
        </StyledWrapper>
    );
    
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderCarrierAccount),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage","OrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;
